import { render, staticRenderFns } from "./ReceptionResumeKG.vue?vue&type=template&id=711d60b2"
import script from "./ReceptionResumeKG.vue?vue&type=script&lang=js"
export * from "./ReceptionResumeKG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports